import LogRocket from 'logrocket'
import setupLogRocketReact from 'logrocket-react'
import { isProd } from 'lib/env'

export default function initLogger ({ identifier }) {
  if (!isProd || !identifier) return
  LogRocket.init(identifier)
  setupLogRocketReact(LogRocket)
}
